import { render, staticRenderFns } from "./PackageCard.vue?vue&type=template&id=097925db&scoped=true"
import script from "./PackageCard.vue?vue&type=script&lang=js"
export * from "./PackageCard.vue?vue&type=script&lang=js"
import style0 from "./PackageCard.vue?vue&type=style&index=0&id=097925db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097925db",
  null
  
)

export default component.exports